import React, { useMemo, useState } from 'react';
import { Card, Button, Result, Row, Col, Radio, Switch, Input } from 'antd';
import { useQuery } from 'react-query';
import { useNavigate, useLocation , Link } from 'react-router-dom';
import DF from 'DisplayFramework';
import { GetAssetListByAnyRefParams } from '../../services/assets';

import { getFinAssetListByAnyRef } from '../../services/finassets';
import { toCurrency } from 'utils/utils';
import DataGrid from 'components/DataGrid';
import { DataGridColDef, DataGridProps } from 'components/DataGrid/DataGrid';
import { PlusOutlined } from '@ant-design/icons';
import GetLabel from 'DisplayFramework/components/GetLabel';
import ModalControllerNV from 'components/ModalControllerNV';
import ConversionAssetModal from './ConversionAssetModal';
import FormInput from 'components/FormInput';
import { getProcTaskInit } from 'services/workflow';
import _ from 'lodash';
import UtinaCard from 'components/UtinaCard';
import Title from 'components/Title';

type AssetListProps = Pick<DataGridProps<any>, 'rowSelection'>;

const AssetListConvert = (props: AssetListProps) => {
  const [modeSearch, setModeSearch] = useState('searchByFamily');
  const [task, setTask] = useState<any>();

  const [step, setStep] = useState(1);
  const [chassisno, setChassisno] = useState('');
  const [assetClass, setAssetClass] = useState('');


  const initialSearchParams: GetAssetListByAnyRefParams = {
    assetreference: '',
    clientname: '',
    clientreference: '',
    ctreference: '',
    deliveryreference: '',
    manufacturername: '',
    manufacturerreference: '',
    orderreference: '',
    propreference: '',
    refsupplier: '',
    assetlabel: '',
    suppliername: '',
    status: '',
    chassisno: '',
    plateno: '',
    assetclass: '',
  };

  const { data, isError } = useQuery(
    [
      'getProcTaskInit',
      {
        entity: 'CONTRACT',
        entityid: 0,
        funcode: 'evLoanRescheduling' ?? '',
        action: '',
        prcode: 'WHOLESALE',
      },
    ],
    () =>
      getProcTaskInit({
        entity: 'CONTRACT',
        entityid: Number(localStorage.getItem('tpid')) ?? 0,
        funcode: 'evLoanRescheduling' ?? '',
        action: '',
        prcode: 'WHOLESALE',
      }).then((result) => {
        if (result.list.length > 0) {
          setTask(result.list[0]);
        }
      }),
    {
      staleTime: 5000,
    }
  );

  //   localStorage.setItem('lphase', lphase);
  const phases = 'PROPOSAL';
  const lphase = 'PROPOSAL';

  const [searchParams, setSearchParams] =
    useState<GetAssetListByAnyRefParams>(initialSearchParams);
  const [searchs, setsearchs] = useState(true);

  const [success, setSuccess] = useState<boolean | null>(null);

  const [listAsset, setListAsset] = useState<any[]>([]);

  const {
    data: assets,
    isFetching,
    refetch,
  } = useAssets(searchParams, phases, searchs);

  const columns = useMemo<DataGridColDef<any>[]>(
    () => [
      {
        dataIndex: 'chassisno',
        width: 100,
        fixed: 'left',
      },
      {
        dataIndex: 'assetreference',
        filtrable: true,
        render: (assetreference, record) => {
          return assetreference;
        },
        fixed: 'left',
        width: 150,
      },
      {
        dataIndex: 'assetlabel',
        filtrable: true,
        render: (assetlabel, record) => {
          return assetlabel;
        },
        fixed: 'left',
        width: 300,
      },
      {
        dataIndex: 'propreference',
        width: 150,
      },

      {
        dataIndex: 'assettypelabel',
        width: 150,
      },
      {
        dataIndex: 'assetcategorylabel',
        width: 200,
      },

      {
        dataIndex: 'assetgrossamount',
        width: 150,
        align: 'right',
        render: (value, record) => toCurrency(value, record.currcode),
      },
      {
        dataIndex: 'assetnetamount',
        align: 'right',
        width: 130,
        fixed: 'right',
        render: (value, record) => toCurrency(value, record.currcode),
      },
      {
        dataIndex: 'status',
        render: (val, record) => record.statuslabel,
        fixed: 'right',
        width: 120,
      },
    ],
    [lphase, refetch]
  );

  return (
    <DF.Provider pagcode="conversionfamily">
      <Card>
        <Row justify="start">
          <Title comcode="conversionfamily" level={2} color="#243882" />
        </Row>
        <Row justify="center">
          <Col span={12}>
            {modeSearch === 'searchByFamily' ? (
              <Row justify="center">
                <UtinaCard
                  style={{ width: 700, height: 110 }}
                  comcode="searchByFamily"
                  level={4}
                >
                  <Radio.Group
                    onChange={(e) => {
                      setAssetClass(e.target.value);
                      setSearchParams({
                        ...initialSearchParams,
                        assetclass: e.target.value,
                      });
                    }}
                    style={{ margin: '0px 100px' }}
                  >
                    <Radio
                      value="NC"
                      style={{ marginBottom: 20, marginRight: 30 }}
                    >
                      <GetLabel style={{ fontSize: 17 }} label="Nc_label" />
                    </Radio>

                    <Radio
                      value="DC"
                      style={{ marginBottom: 20, marginRight: 30 }}
                    >
                      <GetLabel style={{ fontSize: 17 }} label="Dc_label" />
                    </Radio>
                    <br />
                    <Radio
                      value="UC"
                      style={{ marginBottom: 20, marginRight: 27 }}
                    >
                      <GetLabel style={{ fontSize: 17 }} label="Uc_label" />
                    </Radio>

                    <Radio
                      value="VNF"
                      style={{ marginBottom: 20, marginRight: 27 }}
                    >
                      <GetLabel style={{ fontSize: 17 }} label="Vnf_label" />
                    </Radio>
                  </Radio.Group>
                </UtinaCard>
              </Row>
            ) : (
              <Row justify="center">
                <UtinaCard
                  style={{ width: 700, height: 120 }}
                  comcode="searchSpecific"
                  level={4}
                >
                  <Row justify="center">
                    <FormInput col md={18} name="chassisno">
                      <Input
                        onChange={(e) => {
                          setSearchParams({
                            ...initialSearchParams,
                            chassisno: e.target.value,
                          });
                        }}
                      />
                    </FormInput>
                    <FormInput
                      col
                      md={18}
                      name="registrationnumber"
                    ></FormInput>
                  </Row>
                </UtinaCard>
              </Row>
            )}
          </Col>
          <Col span={4} style={{ paddingLeft: 5 }}>
            <Card
              style={{ width: 240, height: 144, marginTop: 20 }}
              size="small"
            >
              <FormInput
                name="flagrebilling"
                valuePropName="checked"
                noStyle
                style={{ width: '200px', marginBottom: '20px' }}
              >
                <Switch
                  size="default"
                  checkedChildren="searchByFamily"
                  unCheckedChildren="searchSpecific"
                  onChange={(e, val) => {
                    setModeSearch(e ? 'searchSpecific' : 'searchByFamily');
                  }}
                />
              </FormInput>
              <Button
                onClick={() => {
                  setStep(2);
                  refetch();
                }}
                type="primary"
                style={{ width: '200px' }}
                disabled={assetClass === ''}
              >
                Search
              </Button>
            </Card>
          </Col>
        </Row>
      </Card>

      {step === 2 && (
        <div>
          {modeSearch === 'searchByFamily' && (
            <Card style={{ marginTop: 5 }}>
              {success == null && (
                <DataGrid
                  scroll={{ x: 1500, y: 400 }}
                  titleComcode="listAssetToConvert"
                  pagination={{ pageSize: 50 }}
                  dataSource={assets ?? []}
                  rowKey={(record) => record.assetid}
                  columns={columns}
                  componentName="asset_list"
                  onSearch={(values) => {
                    setSearchParams({ ...values });
                    //   setdatasource(assets);
                    setsearchs(true);
                    refetch();
                  }}
                  initialSearchValues={initialSearchParams}
                  hideFilters
                  isLoading={isFetching}
                  rowSelection={{
                    hideSelectAll: true,
                    type: 'checkbox',
                    onChange: (selectedKeys, selectedRowKeys) => {
                      setListAsset(selectedRowKeys);
                    },
                    selectedRowKeys: listAsset.map((e) => e.assetid),
                  }}
                  extraActions={
                    <ModalControllerNV
                      modal={({ setVisible, visible }) => (
                        <ConversionAssetModal
                          onCancel={() => {
                            setVisible(false);
                            // setSuccess(false);
                          }}
                          task={task}
                          visible={visible}
                          onSuccess={() => {
                            setVisible(false);
                            setSuccess(true);
                          }}
                          listAsset={listAsset}
                          title="CONVERSION REQUEST BY VIN"
                          assetclass={searchParams.assetclass}
                        />
                      )}
                      content={({ setVisible, visible }) => (
                        <Button
                          icon={<PlusOutlined />}
                          type="primary"
                          onClick={() => {
                            setVisible(true);
                          }}
                        >
                          CONVERT YOUR SELECTION
                        </Button>
                      )}
                    />
                  }
                />
              )}

              {success === true ? (
                <Row justify="center">
                  <Card style={{ width: 900 }}>
                    <Result
                      status="success"
                      title="YOUR REQUEST IS BEING PROCESSED BY BACK-OFFICE ! "
                      subTitle="YOU WILL BE NOTIFIED ABOUT THE DECISION. YOU CAN HAVE THE INFORMATION ABOUT ALL YOUR
             REQUESTS IN :"
                      extra={[
                        <Link key="1" to="/conversionFamily">
                          aaaa
                        </Link>,
                      ]}
                      style={{ background: '#F5F5F5' }}
                    />
                  </Card>
                </Row>
              ) : (
                success === false && (
                  <Row justify="center">
                    <Card style={{ width: 900, background: '#F5F5F5' }}>
                      <Result
                        status="error"
                        title="YOUR REQUEST IS BEING PROCESSED BY BACK-OFFICE ! "
                        subTitle="YOU WILL BE NOTIFIED ABOUT THE DECISION. YOU CAN HAVE THE INFORMATION ABOUT ALL YOUR
                     REQUESTS IN :"
                        extra={[
                          <Link key="1" to="/conversionFamily">
                            aaaa
                          </Link>,
                        ]}
                        style={{ background: '#F5F5F5' }}
                      />
                    </Card>
                  </Row>
                )
              )}
            </Card>
          )}
        </div>
      )}
    </DF.Provider>
  );
};

const useAssets = (searchParams: any, assetPhase: string, searchs: boolean) => {
  const finAssetsQuery = useQuery(
    ['getFinAssetListByAnyRef', searchParams],
    () =>
      getFinAssetListByAnyRef(searchParams).then(
        (res) => _.uniqBy(res.list, 'assetid') || []
      )
  );
  return finAssetsQuery;
};

export default AssetListConvert;
